export default "__VITE_ASSET__DmyRFWfW__"